import { withNamespaces } from 'react-i18next';
import { Card, CardBody } from 'reactstrap';

const FolderPlaceholder = ({
    t,
    folder,
}) => {
    const folderLabels = {
        inbox: t('Inbox'),
        sent: t('Sent Mail'),
        trash: t('Trash'),
        starred: t('Starred'),
    };

    return (
        <Card>
            <CardBody>
                <h5 className="mb-3">
                    {folderLabels[folder] || t('Inbox')}
                </h5>
                <p className="text-muted mb-0">
                    {t('This folder is empty.')}
                </p>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(FolderPlaceholder);
